import {useMemo} from 'react';
import {useParams, Link as RouterLink} from 'react-router-dom';
import {Box, Chip, Container, Divider, Link, Typography} from '@mui/material';
import {findManualBySlug} from 'src/data/userManuals';

export default function UserManualShowPage() {
	const fallbackImage = '/static/backgrounds/gradientwavebackground.png';
	const {slug} = useParams();
	const manual = useMemo(() => findManualBySlug(slug), [slug]);

	if (!manual) {
		return (
			<Container maxWidth="md" sx={{py: 6}}>
				<Typography variant="h5" sx={{fontWeight: 700}}>
					Manual not found
				</Typography>
				<Typography variant="body2" color="text.secondary" sx={{mt: 1}}>
					We couldn't find this manual. It may have been moved.
				</Typography>
				<Link component={RouterLink} to="/manuals" sx={{mt: 2, display: 'inline-block'}}>
					Back to manuals
				</Link>
			</Container>
		);
	}

	return (
		<Container maxWidth="md" sx={{py: 6}}>
			<Link component={RouterLink} to="/manuals" sx={{mb: 2, display: 'inline-block'}}>
				← Back to manuals
			</Link>

			<Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
				<Typography variant="h3" sx={{fontWeight: 800}}>
					{manual.title}
				</Typography>
				{manual.updatedAt && (
					<Chip size="small" label={`Updated: ${manual.updatedAt}`} variant="outlined" />
				)}
			</Box>

			<Typography variant="subtitle1" color="text.secondary" sx={{mt: 1}}>
				{manual.summary}
			</Typography>

			<Box
				sx={{
					borderRadius: 2,
					overflow: 'hidden',
					mt: 3,
					boxShadow: (theme) => theme.shadows[2],
				}}
			>
				<Box
					component="img"
					src={manual.image || fallbackImage}
					alt={`${manual.title} cover`}
					sx={{width: '100%', height: 260, objectFit: 'cover'}}
				/>
			</Box>

			<Divider sx={{my: 3}} />

			<Box>
				{manual.content.map((p, idx) => (
					<Typography key={idx} variant="body1" sx={{mb: 2, lineHeight: 1.8}}>
						{p}
					</Typography>
				))}
			</Box>
		</Container>
	);
}
